import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutFocusSetRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutFocusSetRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStageLayoutFocusSetRequest) {
    JsonSchemaValidator.assert(
      RoomStageLayoutFocusSetRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

interface RoomStageLayoutFocusSetRequest {
  roomId: RoomId;
  streamId: StreamId;
}
